import Swiper, {EffectFade} from 'swiper';
import SimpleBar from 'simplebar';

const params = {
    parentSelector: '.js-tabs-slider',
    containerSelector: '.js-tabs-slider .swiper-container',
};

Swiper.use([EffectFade]);

// eslint-disable-next-line consistent-return
export function initTabsSlider() {
    let init = false;

    // eslint-disable-next-line consistent-return
    $(window).on('load resize', () => {
        if ($(window).width() <= 574) {
            // debugger;
            if (init && $('.js-tabs-slider .swiper-container').length) {
                init = false;
                return tabsSlider.destroy();
            }

            if (!init) {
                /* фикс высоты swiper на главной */
                let $equipmentSwiperContainer = $('.equipment-main__content');
                let $equipmentSwiperWrapper = $('.equipment-main__content .swiper-wrapper');
                if ($equipmentSwiperContainer.length) {

                    let $firstBlockHeightEquipment = $equipmentSwiperContainer.find('[data-slide-id=nav-equipment-main-1] > .row')
                    $equipmentSwiperWrapper.height($firstBlockHeightEquipment.height());
                }

                let $coffeeSwiperContainer = $('.coffee-main__content');
                let $coffeeSwiperWrapper = $('.coffee-main__content .swiper-wrapper');
                if ($coffeeSwiperContainer.length) {
                    let $firstBlockHeightCoffee = $coffeeSwiperContainer.find('[data-slide-id=nav-coffee-main-1] > div > .row')
                    $coffeeSwiperWrapper.height($firstBlockHeightCoffee.height());
                }
                return false;
            }
        }
        if ($(window).width() > 574) {
            if (!init) {
                init = true;
                const containers = $(params.parentSelector);

                if (!containers.length) {
                    return false;
                }

                $(containers).each((index, container) => {
                    const sliderContainer = $(container).find('.swiper-container')[0];
                    const tabsNavigation = $(container).closest('.app-tabs').find('.js-tabs-nav-slider')[0];

                    let customScroll = null;
                    const scrollParams = {};

                    if (tabsNavigation) {
                        // eslint-disable-next-line no-unused-vars
                        customScroll = new SimpleBar(tabsNavigation, scrollParams);
                    }

                    const scrollToTabBtn = (navContainer) => {
                        const scrollContainer = $(navContainer).find('.simplebar-content-wrapper');
                        const activeTab = $(navContainer).find('.nav-item.active');
                        const scrollPosition = activeTab[0].offsetLeft - tabsNavigation.offsetWidth / 2 + activeTab[0].offsetWidth / 2;

                        scrollContainer.animate({ scrollLeft: scrollPosition }, 300);
                    };

                    const setActiveTab = (currentSlideIndex) => {
                        const currentSlide = container.querySelector(`[data-swiper-slide-index="${currentSlideIndex}"]`);
                        const currentSlideId = currentSlide.dataset.slideId;
                        $(tabsNavigation).find(`[href="#${currentSlideId}"]`).tab('show');
                        scrollToTabBtn(tabsNavigation);
                    };

                    const tabsSlider = new Swiper(sliderContainer, {
                        loop: true,
                        simulateTouch: false,
                        autoHeight: true,
                        spaceBetween: 32,
                        slidersPerView: 1,
                        effect: 'fade',
                        fadeEffect: {
                            crossFade: true,
                        },
                        on: {
                            slideChange: (swiper) => {
                                setActiveTab(swiper.realIndex);
                                $(swiper.$el).find('.swiper-wrapper').removeClass('h-auto');
                            },
                        },
                    });

                    const changeSlideOnTabBtn = () => {
                        $(tabsNavigation).find('.nav-item').on('click', (e) => {
                            const currentSlideId = e.target.hash.replace(/^#/, '');
                            const currentSlideIndex = container.querySelector(`[data-slide-id="${currentSlideId}"]`).dataset.swiperSlideIndex;
                            tabsSlider.slideTo(+currentSlideIndex + 1);
                        });
                    };

                    changeSlideOnTabBtn();
                });
            }
            if (init) {
                return false;
            }
        }
    });
}
